module.exports = __webpack_public_path__ + "static/img/piglet5.3450e5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/piglet5.png
// module id = oQZh
// module chunks = 2